import { cloneDeep } from "lodash";

import BaseCommand from "./baseCommand";

class SignatureSignerChangeCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
    this.preventNukeActiveState = true;
  }

  execute() {
    const {
      data,
      event: e,
      index: i,
      onSectionUpdate,
      setState,
    } = this.componentData;
    const newData = cloneDeep(data);
    newData[i].signer_email = e.value;
    newData[i].first_name = e.firstName;
    newData[i].last_name = e.lastName;
    newData[i].signer_config = { ...newData[i].signer_config };
    newData[i].signer_config.image_url = e.image_url;
    newData[i].showNameField = false;
    newData[i].internalUser = true;
    newData[i].signer_config.signature_type =
      newData[i].signer_config.signature_type;
    newData[i].signer_config.showAuth = false;
    setState(() => ({ signBlocks: newData }));
    onSectionUpdate(newData[i], false, newData);
  }

  undo() {
    const {
      data,
      index: signerIndex,
      onSectionUpdate,
      setState,
    } = this.componentData;
    const newData = cloneDeep(data);
    setState(() => ({ signBlocks: newData }));
    onSectionUpdate(newData[signerIndex], false, newData);
  }
}

export default SignatureSignerChangeCommand;



// WEBPACK FOOTER //
// ./src/commands/signatureSignerChangeCommand.js